export default __webpack_public_path__ + "static/media/methodology.bee63c16.pdf";